const keyPressed = (provider, event) => {
    let p = provider.p;

    if (!provider.enableHotKeys) {
        let searchTab = provider.sideBar.getTab('search');
        if (p.keyCode === 27 && searchTab.focused) {
            searchTab.searchInput.elt.blur();
            return false;

        }
        const activeInput = provider.getTab('info').activeInput;
        if (activeInput
            && (p.keyCode == 27 // Escape
                || (p.keyCode == 13 && !p.keyIsDown(p.SHIFT)))) { // Enter
            activeInput.elt.blur();
            provider.getTab('info').activeInput = null;
        }
        provider.tools.currentTool.pressKeyHotKeysDisabled(p.keyCode);
        return;
    }

    if (onlySubKey(p.ALT, p)) {
        switch (p.keyCode) {
            case 73: // I
                provider.settings.showImage = !provider.settings.showImage;
                return false;
            case 76: // L
                provider.settings.lockLabels = !provider.settings.lockLabels;
                return false;
        }
        return provider.tools.currentTool.pressKeyWithAlt(p.keyCode);
    }

    if (onlySubKey(p.CONTROL, p)) {
        switch (p.keyCode) {
            case 83: // S
                event.preventDefault();
                provider.savePlan();
                return false;
            case 89: // Y
                event.preventDefault();
                provider.actions.redo();
                return false;
            case 90: // Z
                event.preventDefault();
                provider.actions.undo();
                return false;
        }
        return provider.tools.currentTool.pressKeyWithControl(p.keyCode);
    }

    if (onlySubKey(p.SHIFT, p)) {
        switch (p.keyCode) {
            case 69: // E
                provider.tools.setTool('erase');
                return false;
            case 71: // G
                provider.settings.showGrid = !provider.settings.showGrid;
                return false;
            case 73: // I
                provider.tools.setTool('image');
                return false;
            case 76: // L
                provider.settings.showLabels = !provider.settings.showLabels;
                return false;
            case 82: // R
                provider.view.reset();
                return false;
            case 83: // S
                provider.settings.snapToGrid = !provider.settings.snapToGrid;
                return false;
        }
        return provider.tools.currentTool.pressKeyWithShift(p.keyCode);
    }

    switch (p.keyCode) {
        case 65: // A
            provider.tools.setTool('shapes');
            return;
        case 67: // C
            provider.tools.setTool('select');
            return;
        case 69: // E
            provider.sideBar.setTab('elements');
            return;
        case 72: // H
            provider.tools.setTool('help');
            return;
        case 73: // I
            provider.sideBar.setTab('info');
            return;
        case 76: // L
            provider.sideBar.setTab('lists');
            return;
        case 78: // N
            provider.tools.setTool('navigate');
            return;
        case 80: // P
            provider.sideBar.setTab('plants');
            return;
        case 83: // S
            provider.sideBar.setTab('search');
            setTimeout(() => provider.sideBar.getTab('search').searchInput.elt.focus(), 10);
            return;
        case 89: // Y
            provider.sideBar.setTab('layers');
            return;
        case 187: // +
            provider.view.zoomIn();
            return;
        case 188: // ,
            provider.tools.setTool('settings');
            return;
        case 189: // -
            provider.view.zoomOut();
            return;
    }

    return provider.tools.currentTool.pressKey(p.keyCode);
}

const onlySubKey = (code, p) => {
    let subKeys = [
        p.CONTROL,
        p.SHIFT,
        p.ALT,
    ];

    return p.keyIsDown(code)
        && subKeys.filter(subKey => p.keyIsDown(subKey)).length === 1;
}

const registerSpacebarListeners = (provider) => {
    document.body.addEventListener('keydown', (event) => {
        if (event.code === 'Space' && !event.repeat && provider.enableHotKeys) {
            provider.tools.setTool('navigate');
        }
    });

    document.body.addEventListener('keyup', (event) => {
        if (event.code === 'Space' && provider.enableHotKeys) {
            provider.tools.setPreviousTool();
        }
    });
}

export { keyPressed, registerSpacebarListeners };
